import { applyMiddleware, compose, createStore } from "redux"
import defaultState from "../data"
import rootReducer from "../reducers"
import thunkMiddleware from "redux-thunk"


const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const configureStore = () =>
  createStore(
    rootReducer,
    defaultState,
    composeEnhancers(applyMiddleware(thunkMiddleware))
  )

export default configureStore